import { api, otherApiClient } from ".";
export const getCurrentCart = async ()=>{
    const { data  } = await api.get("/carts/current");
    return data;
};
export var OrderType;
(function(OrderType) {
    OrderType[OrderType["NORMAL"] = 0] = "NORMAL";
    OrderType[OrderType["PAID_BY_ADMIN"] = 100] = "PAID_BY_ADMIN";
    OrderType[OrderType["PAID_BY_USER"] = 200] = "PAID_BY_USER";
})(OrderType || (OrderType = {}));
export const postCreateOrderFromCart = async (dto)=>{
    const { data  } = await api.post("/orders/from-cart", dto);
    return data;
};
export const getCart = async (params)=>{
    const { data  } = await otherApiClient.market("/carts/current", {
        params
    });
    return data;
};
export const getCartsCount = async ()=>{
    const { data  } = await otherApiClient.market("/carts/counts");
    return data;
};
